import 'babel-polyfill';
import {BodyComponent} from "../components/body/body-component";
import {Form} from "../components/form/form";
import {FormField} from "../components/form-field/form-field";
import {FormFieldChecks} from "../components/form-field-checks/form-field-checks";
import {FormFieldDate} from "../components/form-field-date/form-field-date";
import {FormFieldInput} from "../components/form-field-input/form-field-input";
import {FormFieldRadio} from "../components/form-field-radio/form-field-radio";
import {FormFieldSelect} from "../components/form-field-select/form-field-select";
import {FormFieldTextarea} from "../components/form-field-textarea/form-field-textarea";
import {FormFieldTextInformation} from "../components/form-field-text-information/form-field-text-information";
import {FormFieldGeoLocation} from "../components/form-field-geo-location/form-field-geo-location";
import {FormFieldCutOnPlan} from "../components/form-field-cut-on-plan/form-field-cut-on-plan";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import {FormFieldSelectImage} from "../components/form-field-select-image/form-field-select-image";
import {ModHeader} from "../components/mod-header/mod-header";
import {ModFooter} from "../components/mod-footer/mod-footer";
import {ProductConfigFieldHelp} from "../components/product-config-field-help/product-config-field-help";
import {ProductConfigSummary} from "../components/product-config-summary/product-config-summary";
import {BudgetSummary} from "../components/budget-summary/budget-summary";
import {Cookies} from "../components/cookies/cookies";

GvfUiService.registerComponent(".js-body",BodyComponent);
GvfUiService.registerComponent(".js-form",Form);
GvfUiService.registerComponent(".js-form-field",FormField);
GvfUiService.registerComponent(".js-form-field-checks",FormFieldChecks);
GvfUiService.registerComponent(".js-form-field-date",FormFieldDate);
GvfUiService.registerComponent(".js-form-field-input",FormFieldInput);
GvfUiService.registerComponent(".js-form-field-radio",FormFieldRadio);
GvfUiService.registerComponent(".js-form-field-select",FormFieldSelect);
GvfUiService.registerComponent(".js-form-field-select-image",FormFieldSelectImage);
GvfUiService.registerComponent(".js-form-field-text-information",FormFieldTextInformation);
GvfUiService.registerComponent(".js-form-field-textarea",FormFieldTextarea);
GvfUiService.registerComponent(".js-form-field-geo-location",FormFieldGeoLocation);
GvfUiService.registerComponent(".js-form-field-cut-on-plan",FormFieldCutOnPlan);
GvfUiService.registerComponent(".js-mod-header",ModHeader);
GvfUiService.registerComponent(".js-mod-footer",ModFooter);
GvfUiService.registerComponent(".js-product-config-field-help",ProductConfigFieldHelp);
GvfUiService.registerComponent(".js-product-config-summary",ProductConfigSummary);
GvfUiService.registerComponent(".js-budget-summary",BudgetSummary);
GvfUiService.registerComponent(".js-cookies",Cookies);

GvfUiService.registerDelayedComponent(".js-mod-gvml",()=>import("../components/mod-gvml/mod-gvml"));
GvfUiService.registerDelayedComponent(".js-mod-product-config",()=>import("../components/mod-product-config/mod-product-config"));

GvfUiService.registerDelayedComponent(".js-mod-config-curtain",()=>import("../components/mod-config-curtain/mod-config-curtain"));
GvfUiService.registerDelayedComponent(".js-mod-config-window",()=>import("../components/mod-config-window/mod-config-window"));
GvfUiService.registerDelayedComponent(".js-mod-config-shelving",()=>import("../components/mod-config-shelving/mod-config-shelving"));

GvfUiService.registerDelayedComponent(".js-mod-config-mosquitonet",()=>import("../components/mod-config-mosquitonet/mod-config-mosquitonet"));
GvfUiService.registerDelayedComponent(".js-mod-config-awning",()=>import("../components/mod-config-awning/mod-config-awning"));
GvfUiService.registerDelayedComponent(".js-mod-config-worktop",()=>import("../components/mod-config-worktop/mod-config-worktop"));
GvfUiService.registerDelayedComponent(".js-mod-cart-detail",()=>import("../components/mod-cart-detail/mod-cart-detail"));
GvfUiService.registerDelayedComponent(".js-mod-checkout",()=>import("../components/mod-checkout/mod-checkout"));
GvfUiService.registerDelayedComponent(".js-mod-lead",()=>import("../components/mod-lead/mod-lead"));
